import { gql } from '@apollo/client';
import { ModifyEnvironmentInput } from 'types/Environment';

const updateEnvironment = (
    environmentUri: string,
    input: ModifyEnvironmentInput,
) => {
    return {
        variables: {
            environmentUri,
            input,
        },
        mutation: gql`
            mutation UpdateEnvironment(
                $environmentUri: String!
                $input: ModifyEnvironmentInput
            ) {
                updateEnvironment(
                    environmentUri: $environmentUri
                    input: $input
                ) {
                    environmentUri
                    label
                    description
                    region
                    userRoleInEnvironment
                    SamlGroupName
                    SamlFullDevGroupName
                    SamlBasicDevGroupName
                    SamlReaderGroupName
                    originSamlGroupName
                    originSamlFullDevGroupName
                    originSamlBasicDevGroupName
                    originSamlReaderGroupName
                    AwsAccountId
                    AwsProdAccountId
                    AwsDevAccountId
                    AwsTestAccountId
                    AwsToolAccountId
                    AwsValAccountId
                    environmentStage
                    blockpreview
                    quicksight_enabled
                }
            }
        `,
    };
};

export default updateEnvironment;
